import { Component } from '@angular/core';
import {DynamicDialogRef} from "primeng/dynamicdialog";

@Component({
  selector: 'app-blacklist-user-popup',
  templateUrl: './blacklist-user-popup.component.html',
  styleUrls: ['./blacklist-user-popup.component.scss']
})
export class BlacklistUserPopupComponent {

  constructor(
    private ref: DynamicDialogRef,
  ) {}

  close(status: boolean = false) {
    this.ref.close(status);
  }

  accept() {
    this.close(true);
  }

}
